import React from 'react'

function AboutView() {
  return (
    <div>
      About View
    </div>
  )
}

export default AboutView
